module.exports = __webpack_public_path__ + "img/duel_bioplant.128a1f73.png";